import { connect } from 'react-redux';
import { readingActions } from '../../../actions';
import { ReadingControls as ReadingControlsView } from '../../design/Episode/ReadingControls';
import { enableBrowserFullscreen, disableBrowserFullscreen } from "../helpers";

class ReadingControls extends React.Component {

  componentDidMount = () => {
    document.addEventListener('webkitfullscreenchange', this.exitFullscreenHandler, false);
    document.addEventListener('mozfullscreenchange', this.exitFullscreenHandler, false);
    document.addEventListener('fullscreenchange', this.exitFullscreenHandler, false);
    document.addEventListener('MSFullscreenChange', this.exitFullscreenHandler, false);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.currentPage != nextProps.currentPage) {
      this.props.currentPageSet(nextProps.currentPage)
    }
  }

  exitFullscreenHandler = () => {
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      this.disableFullscreen();
    }
  };

  toggleFullscreen = () => {
    this.props.fullscreen
      ? this.disableFullscreen()
      : this.enableFullscreen();
  };

  disableFullscreen = () => {
    disableBrowserFullscreen();
    this.toggleFullscreenClasses('remove');
    this.props.fullscreenOff();
  };

  enableFullscreen = () => {
    enableBrowserFullscreen();
    this.toggleFullscreenClasses('add');
    this.props.fullscreenToggle()
  };

  toggleFullscreenClasses = (toggleMode) => {
    document.getElementsByTagName('header')[0].classList[toggleMode]('fullscreen');
    document.getElementsByClassName('a-header-menu')[0].classList[toggleMode]('fullscreen');
    document.getElementsByClassName('scrollreader')[0].classList[toggleMode]('fullscreen');
  };

  prevPageClicked = (event) => {
    event.preventDefault();
    if (this.props.currentPage > 1){
      this.props.currentPageSetWithThunk(this.props.currentPage - 1);
    }
  };

  nextPageClicked = (event) => {
    event.preventDefault();
    if (this.props.currentPage < this.props.pagesCount){
      this.props.currentPageSetWithThunk(this.props.currentPage + 1)
    }
  };

  render = () => (
    <ReadingControlsView
      prevPageClicked={this.prevPageClicked}
      nextPageClicked={this.nextPageClicked}
      toggleFullscreen={this.toggleFullscreen}
      {...this.props}
    />
  )
}

const mapState = (state, ownProps) => ({
  pagesCount: state.currentEpisode.pages && state.currentEpisode.pages.length,
  t: I18n.t('landing.scrollreader_reading_controls'),
  ...state.reading
});

const mapDispatch = (dispatch, ownProps) => ({
  currentPageSetWithThunk: (currentPage) => { dispatch(readingActions.currentPageSetWithThunk(currentPage)) },
  currentPageSet: (currentPage) => { dispatch(readingActions.currentPageSet(currentPage)) },
  fullscreenOff: () => { dispatch(readingActions.fullscreenOff()) },
  fullscreenToggle: () => { dispatch(readingActions.fullscreenToggle()) },
  zoomIn: () => { dispatch(readingActions.zoomIn()) },
  zoomOut: () => { dispatch(readingActions.zoomOut()) }
});

export default connect(mapState, mapDispatch)(ReadingControls);